module.exports = __webpack_public_path__ + "static/media/logoArtConcursosDark.ce92c07b.svg";